module.exports = __webpack_public_path__ + "img/1.dc612fae.jpg";